import { useState, useEffect } from 'react';
import axios from 'axios';

// Shared bits for the native record pages (tasks #62/#60). Same formatting
// conventions as the nativeitems screens.

export const fmtQty = (n) => (n == null ? '—' : Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 }));
export const fmtMoney = (n, digits = 2) =>
  (n == null || Number.isNaN(Number(n)) ? '—' : `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`);
export const fmtDate = (d) => (d ? String(d).slice(0, 10) : '—');
export const fmtStamp = (d) => (d ? new Date(d).toLocaleString() : 'unknown');
export const yesNo = (v) => (v == null ? '—' : v === true || v === 'T' ? 'Yes' : 'No');

// NetSuite status letter → label maps (same as the global-search server).
// Also keyed by the words STATUS_MAPS.SalesOrd stores in sales_orders.status,
// since the mirror holds those and raw letters side by side.
export const SO_STATUS = {
  A: 'Pending Approval', B: 'Pending Fulfillment', C: 'Cancelled',
  D: 'Partially Fulfilled', E: 'Pending Billing / Partially Fulfilled',
  F: 'Pending Billing', G: 'Billed', H: 'Closed',
  pending_approval: 'Pending Approval', pending_fulfillment: 'Pending Fulfillment',
  cancelled: 'Cancelled', partially_fulfilled: 'Partially Fulfilled',
  pending_billing_partially_fulfilled: 'Pending Billing / Partially Fulfilled',
  pending_billing: 'Pending Billing', billed: 'Billed', closed: 'Closed',
};
export const statusLabel = (map, s) => (s && map[s]) || s || '—';

/** Fetch one record detail payload; refetches when the url changes. */
export function useRecordDetail(url) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  useEffect(() => {
    let cancelled = false;
    setState({ data: null, loading: true, error: null });
    axios
      .get(url)
      .then(({ data }) => { if (!cancelled) setState({ data, loading: false, error: null }); })
      .catch((err) => { if (!cancelled) setState({ data: null, loading: false, error: err.response?.data?.error || err.message }); });
    return () => { cancelled = true; };
  }, [url]);
  return state;
}
